const itemsCategoriesPath = '/items/categories';
export default itemsCategoriesPath;
